export default "__VITE_ASSET__lPpP1S10__"